// extracted by mini-css-extract-plugin
export default {"formData":"FormData_formData__pcsqc"};